import { useState } from 'react';
import { useAnalysisNotes } from './hooks/useAnalysisNotes';
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import type { Analysis } from '../../types/models';

interface AnalysisNotesProps {
  analysis: Analysis;
}

export function AnalysisNotes({ analysis }: AnalysisNotesProps) {
  const [isEditing, setIsEditing] = useState(false);
  const { updateNotes, isLoading } = useAnalysisNotes(analysis?.id ?? '');
  const [notes, setNotes] = useState(analysis.notes || '');

  const handleSave = async () => {
    if (!analysis?.id) {
       console.error("Cannot save notes without analysis ID.");
       return; 
    }
    try {
      await updateNotes(notes);
      setIsEditing(false);
    } catch (error) {
      setIsEditing(true);
    }
  };

  const handleCancel = () => {
    setNotes(analysis.notes || ''); 
    setIsEditing(false);
  }

  return (
    <div>
      {isEditing ? (
        <div className="space-y-4">
          <div className="grid w-full gap-1.5">
            <Label htmlFor={`notes-${analysis?.id}`}>Notes</Label>
            <Textarea
              id={`notes-${analysis?.id}`}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Add your interview notes here..."
              rows={6}
              disabled={isLoading}
            />
           </div>
          <div className="flex justify-end space-x-2">
            <Button
              variant="ghost"
              onClick={handleCancel}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save Notes'}
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <div className="flex justify-end mb-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => setIsEditing(true)}
              >
                Edit Notes
              </Button>
          </div>
          {notes ? (
            <p className="text-sm text-muted-foreground whitespace-pre-wrap break-words">
               {notes}
            </p>
          ) : (
            <p className="text-sm text-muted-foreground italic">
               No notes added yet.
            </p>
          )}
        </div>
      )}
    </div>
  );
}